<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} TEMPERATURAS</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel
            label="TEMPERATURAS"
            width="100%"
            height="100%"
            :size="4"
            color="cyan"
            border="solid 6px yellow"
          ></HmiLabel>
        </div>
        <div class="grid">
          <v-simple-table class="table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th colspan="1"></th>
                  <th colspan="1" class="cyan">
                    <HmiLabel
                      label="LECTURA"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </th>
                  <th colspan="1" class="cyan">
                    <HmiLabel
                      label="REGULACION"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="cyan">
                    <HmiLabel
                      label="COJINETE EXTERIOR"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="gray">
                    <HmiLabel
                      :label="formatoTemperatura(tempCojineteExterior) + ' Gr.'"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="green">
                    <HmiLabel
                      :label="formatoRegulacion(regulacionTempCojineteExterior)"
                      width="100%"
                      height="100%"
                      color="#56FF56"
                      border="0px"
                      :editable="true"
                      @input="escrituraDM($event, direccionVariables.REGULACION_TEMP_COJINETE_EXTERIOR_ESCRITURA, 1)"
                    ></HmiLabel>
                  </td>
                </tr>
                <tr>
                  <td class="cyan">
                    <HmiLabel
                      label="COJINETE INTERIOR"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="gray">
                    <HmiLabel
                      :label="formatoTemperatura(tempCojineteInterior) + ' Gr.'"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="green">
                    <HmiLabel
                      :label="formatoRegulacion(regulacionTempCojineteInterior)"
                      width="100%"
                      height="100%"
                      color="#56FF56"
                      border="0px"
                      :editable="true"
                      @input="escrituraDM($event, direccionVariables.REGULACION_TEMP_COJINETE_INTERIOR_ESCRITURA, 1)"
                    ></HmiLabel>
                  </td>
                </tr>
                <tr>
                  <td class="cyan">
                    <HmiLabel
                      label="PALIER TURBINA"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="gray">
                    <HmiLabel
                      :label="formatoTemperatura(tempPalierTurbina) + ' Gr.'"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                    ></HmiLabel>
                  </td>
                  <td class="green">
                    <HmiLabel
                      :label="formatoRegulacion(regulacionTempPalierTurbina)"
                      width="100%"
                      height="100%"
                      color="inherit"
                      border="0px"
                      :editable="true"
                      @input="escrituraDM($event, direccionVariables.REGULACION_TEMP_PALIER_TURBINA_ESCRITURA, 1)"
                    ></HmiLabel>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="button">
          <HmiButton
            label="SALIR"
            color="silver"
            width="20%"
            height="100%"
            :size="1.7"
            @click.native="navigateToMenu"
          ></HmiButton>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiPantalla from "../HMI/HmiPantalla.vue";
import HmiLabel from "../HMI/HmiLabel.vue";
import HmiButton from "../HMI/HmiButton.vue";

export default {
  name: "TemperaturasPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      if (this.numeroPantalla == 1) {
        return {
          TEMP_COJINETE_EXTERIOR_LECTURA: 42, // Correspondiente a Dm94
          TEMP_COJINETE_INTERIOR_LECTURA: 41, // Correspondiente a Dm93
          TEMP_PALIER_TURBINA_LECTURA: 40, // Correspondiente a Dm92
          REGULACION_TEMP_COJINETE_EXTERIOR_LECTURA: 61, // Correspondiente a Dm142
          REGULACION_TEMP_COJINETE_EXTERIOR_ESCRITURA: "Dm0142", // Correspondiente a Dm142
          REGULACION_TEMP_COJINETE_INTERIOR_LECTURA: 60, // Correspondiente a Dm141
          REGULACION_TEMP_COJINETE_INTERIOR_ESCRITURA: "Dm0141", // Correspondiente a Dm141
          REGULACION_TEMP_PALIER_TURBINA_LECTURA: 59, // Correspondiente a Dm140
          REGULACION_TEMP_PALIER_TURBINA_ESCRITURA: "Dm0140", // Correspondiente a Dm140
        };
      } else {
        return {
          TEMP_COJINETE_EXTERIOR_LECTURA: 45, // Correspondiente a Dm97
          TEMP_COJINETE_INTERIOR_LECTURA: 44, // Correspondiente a Dm96
          TEMP_PALIER_TURBINA_LECTURA: 43, // Correspondiente a Dm95
          REGULACION_TEMP_COJINETE_EXTERIOR_LECTURA: 64, // Correspondiente a Dm145
          REGULACION_TEMP_COJINETE_EXTERIOR_ESCRITURA: "Dm0145", // Correspondiente a Dm145
          REGULACION_TEMP_COJINETE_INTERIOR_LECTURA: 63, // Correspondiente a Dm144
          REGULACION_TEMP_COJINETE_INTERIOR_ESCRITURA: "Dm0144", // Correspondiente a Dm144
          REGULACION_TEMP_PALIER_TURBINA_LECTURA: 62, // Correspondiente a Dm143
          REGULACION_TEMP_PALIER_TURBINA_ESCRITURA: "Dm0143", // Correspondiente a Dm143
        };
      }
    },

    tempCojineteExterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMP_COJINETE_EXTERIOR_LECTURA
        ];
      }
      return "0000";
    },
    tempCojineteInterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMP_COJINETE_INTERIOR_LECTURA
        ];
      }
      return "0000";
    },
    tempPalierTurbina() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMP_PALIER_TURBINA_LECTURA
        ];
      }
      return "0000";
    },
    regulacionTempCojineteExterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.REGULACION_TEMP_COJINETE_EXTERIOR_LECTURA
        ];
      }
      return "0000";
    },
    regulacionTempCojineteInterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.REGULACION_TEMP_COJINETE_INTERIOR_LECTURA
        ];
      }
      return "0000";
    },
    regulacionTempPalierTurbina() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.REGULACION_TEMP_PALIER_TURBINA_LECTURA
        ];
      }
      return "0000";
    },
  },
  components: {
    HmiPantalla,
    HmiLabel,
    HmiButton,
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "5", this.numeroPantalla);
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "5", this.numeroPantalla);
    },

    // Formatear temeperaturas
    formatoTemperatura(dato) {
      const signo = dato.substring(0, 1);
      dato = dato.substring(1, 4);
      if (signo == "F") {
        return "-" + dato;
      } else {
        return dato;
      }
    },

    formatoRegulacion(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  padding-top: 20px;
  height: 65%;
}

.table {
  background-color: transparent;
  width: 100%;
  height: 70%;
}

.button {
  display: flex;
  justify-content: flex-end;
  height: 15%;
}
.cyan {
  background-color: cyan !important;
  border: solid 1px !important;
}

.gray {
  background-color: silver !important;
  border: solid 1px !important;
}

.green {
  background-color: #56ff56 !important;
  border: solid 1px !important;
}

th,
td {
  width: 33%;
  font-size: clamp(10px, 2.3vw, 21px) !important;
  font-weight: normal !important;
  height: 40px !important;
  padding: 0px !important;
}
</style>
